import { konstants } from '@vizeat/helpers'
const { HOST_APPLICATION_SCHEMA_VERSION, HOST_APPLICATION_STATUSES } = konstants

export const STEPS = [
  '/host-application/welcome',
  '/host-application/about-you',
  '/host-application/your-motivations',
  '/host-application/your-story',
  '/host-application/your-culinary-experience',
  '/host-application/your-venue',
  '/host-application/your-photos',
  '/host-application/our-policy-and-terms-and-conditions',
  '/host-application/congratulations',
]

const WHITELIST_AREAS = {
  Vienna: {
    northeast: { lat: 48.117903, lng: 16.18183 },
    southwest: { lat: 48.322655, lng: 16.577514 },
  },
  Bilbao: {
    northeast: { lat: 43.213663, lng: -2.985815 },
    southwest: { lat: 43.290096, lng: -2.876951 },
  },
  'Donostia/San Sebastian': {
    northeast: { lat: 43.217692, lng: -2.087416 },
    southwest: { lat: 43.357681, lng: -1.888232 },
  },
  Cordoba: {
    northeast: { lat: 37.665823, lng: -4.998599 },
    southwest: { lat: 38.032795, lng: -4.349218 },
  },
  Malaga: {
    northeast: { lat: 36.628877, lng: -4.587889 },
    southwest: { lat: 36.894039, lng: -4.26049 },
  },
  Granada: {
    northeast: { lat: 37.136703, lng: -3.700362 },
    southwest: { lat: 37.225017, lng: -3.496325 },
  },
  Marbella: {
    northeast: { lat: 36.439144, lng: -5.014868 },
    southwest: { lat: 36.55482, lng: -4.726904 },
  },
  Cadiz: {
    northeast: { lat: 36.416798, lng: -6.344634 },
    southwest: { lat: 36.568274, lng: -6.224625 },
  },
  Berlin: {
    northeast: { lat: 52.675502, lng: 13.760906 },
    southwest: { lat: 52.338261, lng: 13.08836 },
  },
  Munich: {
    northeast: { lat: 48.248216, lng: 11.722879 },
    southwest: { lat: 48.061596, lng: 11.360781 },
  },
  Hamburg: {
    northeast: { lat: 54.010088, lng: 10.325247 },
    southwest: { lat: 53.395085, lng: 8.345049 },
  },
  Stuttgart: {
    northeast: { lat: 48.866405, lng: 9.315827 },
    southwest: { lat: 48.692024, lng: 9.038606 },
  },
  Cologne: {
    northeast: { lat: 51.084937, lng: 7.162456 },
    southwest: { lat: 50.830364, lng: 6.772524 },
  },
  'Frankfurt ': {
    northeast: { lat: 50.227136, lng: 8.800405 },
    southwest: { lat: 50.015353, lng: 8.472761 },
  },
  Dublin: {
    northeast: { lat: 53.410991, lng: -6.100801 },
    southwest: { lat: 53.298882, lng: -6.387 },
  },
  Cork: {
    northeast: { lat: 51.970103, lng: -8.35513 },
    southwest: { lat: 51.82731, lng: -8.637854 },
  },
  Belfast: {
    northeast: { lat: 54.66316, lng: -5.757519 },
    southwest: { lat: 54.482496, lng: -6.085283 },
  },
  Galway: {
    northeast: { lat: 53.31931, lng: -8.953457 },
    southwest: { lat: 53.241621, lng: -9.142668 },
  },
  London: {
    northeast: { lat: 51.669993, lng: 0.153177 },
    southwest: { lat: 51.384527, lng: -0.351708 },
  },
  Edinburgh: {
    northeast: { lat: 56.010331, lng: -3.073707 },
    southwest: { lat: 55.868615, lng: -3.3796 },
  },
  Bristol: {
    northeast: { lat: 51.68015, lng: -2.293634 },
    southwest: { lat: 51.27028, lng: -2.872346 },
  },
  Manchester: {
    northeast: { lat: 53.586199, lng: -2.087832 },
    southwest: { lat: 53.348598, lng: -2.52355 },
  },
  Leeds: {
    northeast: { lat: 53.955164, lng: -1.161492 },
    southwest: { lat: 53.719292, lng: -1.800421 },
  },
  Glasgow: {
    northeast: { lat: 56.219682, lng: -3.873909 },
    southwest: { lat: 55.675803, lng: -4.695768 },
  },
  'Brighton ': {
    northeast: { lat: 50.914044, lng: -0.016041 },
    southwest: { lat: 50.779082, lng: -0.24786 },
  },
  Como: {
    northeast: { lat: 45.842221, lng: 9.136937 },
    southwest: { lat: 45.758882, lng: 9.030932 },
  },
  Turin: {
    northeast: { lat: 45.140188, lng: 7.773348 },
    southwest: { lat: 45.006793, lng: 7.577835 },
  },
  Genoa: {
    northeast: { lat: 44.519864, lng: 9.095533 },
    southwest: { lat: 44.359237, lng: 8.665749 },
  },
  Pisa: {
    northeast: { lat: 43.751705, lng: 10.45576 },
    southwest: { lat: 43.576135, lng: 10.241283 },
  },
  Livorno: {
    northeast: { lat: 43.595914, lng: 10.419475 },
    southwest: { lat: 43.400266, lng: 9.861565 },
  },
  Sorrento: {
    northeast: { lat: 40.654908, lng: 14.413823 },
    southwest: { lat: 40.57109, lng: 14.333363 },
  },
  Amalfi: {
    northeast: { lat: 40.648366, lng: 14.624555 },
    southwest: { lat: 40.600617, lng: 14.556513 },
  },
  Matera: {
    northeast: { lat: 40.763678, lng: 16.728258 },
    southwest: { lat: 40.566427, lng: 16.411426 },
  },
  Bari: {
    northeast: { lat: 41.190115, lng: 17.04089 },
    southwest: { lat: 41.014529, lng: 16.717279 },
  },
  Syracuse: {
    northeast: { lat: 37.142997, lng: 15.363687 },
    southwest: { lat: 36.927826, lng: 15.082733 },
  },
  Alghero: {
    northeast: { lat: 40.676092, lng: 8.420276 },
    southwest: { lat: 40.471079, lng: 8.110704 },
  },
  Sassari: {
    northeast: { lat: 40.885564, lng: 8.643558 },
    southwest: { lat: 40.65182, lng: 8.103789 },
  },
  Faro: {
    northeast: { lat: 37.073873, lng: -7.809354 },
    southwest: { lat: 36.961711, lng: -7.976613 },
  },
  Lagos: {
    northeast: { lat: 37.151691, lng: -8.642645 },
    southwest: { lat: 37.079033, lng: -8.723304 },
  },
  'Mykonos island': {
    northeast: { lat: 37.521662, lng: 25.389162 },
    southwest: { lat: 37.346498, lng: 25.171711 },
  },
  'Corfu Island': {
    northeast: { lat: 39.822264, lng: 20.122461 },
    southwest: { lat: 39.360167, lng: 19.628693 },
  },
  'Santorini island': {
    northeast: { lat: 36.482014, lng: 25.487776 },
    southwest: { lat: 36.332172, lng: 25.354231 },
  },
  Split: {
    northeast: { lat: 43.551909, lng: 16.643118 },
    southwest: { lat: 43.426054, lng: 16.290742 },
  },
  Dubrovnik: {
    northeast: { lat: 42.77966, lng: 18.160345 },
    southwest: { lat: 42.601096, lng: 17.815151 },
  },
  Paris: {
    northeast: { lat: 48.902148, lng: 2.469851 },
    southwest: { lat: 48.815562, lng: 2.224229 },
  },
  Lyon: {
    northeast: { lat: 45.80842, lng: 4.898396 },
    southwest: { lat: 45.707481, lng: 4.771859 },
  },
  Nice: {
    northeast: { lat: 43.760909, lng: 7.323476 },
    southwest: { lat: 43.625779, lng: 7.182147 },
  },
  Bordeaux: {
    northeast: { lat: 44.917767, lng: -0.533325 },
    southwest: { lat: 44.810647, lng: -0.638699 },
  },
  Marseille: {
    northeast: { lat: 43.391056, lng: 5.532491 },
    southwest: { lat: 43.153002, lng: 5.201916 },
  },
  Amsterdam: {
    northeast: { lat: 52.431228, lng: 5.093288 },
    southwest: { lat: 52.318248, lng: 4.728759 },
  },
  Utrecht: {
    northeast: { lat: 52.13561, lng: 5.195155 },
    southwest: { lat: 52.026282, lng: 5.008011 },
  },
  Rotterdam: {
    northeast: { lat: 51.994281, lng: 4.601803 },
    southwest: { lat: 51.861667, lng: 4.37931 },
  },
  Budapest: {
    northeast: { lat: 47.613228, lng: 19.337013 },
    southwest: { lat: 47.351513, lng: 18.926022 },
  },
  Prague: {
    northeast: { lat: 50.17741, lng: 14.706783 },
    southwest: { lat: 49.941899, lng: 14.224475 },
  },
  Stockholm: {
    northeast: { lat: 59.37623, lng: 18.18504 },
    southwest: { lat: 59.25671, lng: 17.907666 },
  },
  Copenhagen: {
    northeast: { lat: 55.736801, lng: 12.836121 },
    southwest: { lat: 55.573184, lng: 12.499474 },
  },
  Oslo: {
    northeast: { lat: 60.135106, lng: 10.951387 },
    southwest: { lat: 59.809333, lng: 10.489164 },
  },
  Bergen: {
    northeast: { lat: 60.442943, lng: 5.412655 },
    southwest: { lat: 60.332335, lng: 5.260203 },
  },
}

export const getPrevStep = (pathname) => {
  const currentIndex = STEPS.indexOf(pathname)
  return STEPS[currentIndex - 1]
}

export const getNextStep = (pathname) => {
  const currentIndex = STEPS.indexOf(pathname)
  return STEPS[currentIndex + 1]
}

export const goToNextStep = ({ router }) => {
  const location = router.getCurrentLocation()
  router.push(getNextStep(location.pathname))
}

const STEP_PROGRESS = {
  welcome: null,
  'about-you': { completionRate: 0 },
  'your-motivations': { completionRate: 14 },
  'your-story': { completionRate: 28 },
  'your-culinary-experience': { completionRate: 42 },
  'your-venue': { completionRate: 57 },
  'your-photos': { completionRate: 71 },
  'our-policy-and-terms-and-conditions': { completionRate: 85 },
  congratulations: { completionRate: 100 },
}

export const getStepProgress = (pathname) => {
  const path = pathname.replace('/host-application/', '')
  return STEP_PROGRESS[path]
}

export function isSupportedArea(place) {
  const jsPlace = place?.toJS ? place.toJS() : place
  const lat = jsPlace?.lat || jsPlace?.coordinates?.latitude
  const lng = jsPlace?.lng || jsPlace?.coordinates?.longitude

  if (!jsPlace) return true

  const isSupported = !!Object.values(WHITELIST_AREAS).find(
    ({ northeast, southwest }) =>
      lat <= northeast.lat && lat >= southwest.lat && lng >= southwest.lng && lng <= northeast.lng,
  )

  return isSupported
}

function isStepValid(pathname, data, userFiles) {
  const path = pathname.replace('/host-application/', '')
  const host = data.get('host')
  const experience = data.get('sample_experience')
  const metadata = data.get('metadata')

  switch (path) {
    case 'welcome':
    case 'about-you':
      return true
    case 'your-motivations':
      return isSupportedArea(data.get('place')) && host.get('spoken_languages').size > 0
    case 'your-story':
      return !!host.get('host_typology')
    case 'your-culinary-experience':
      return !!host.get('culinary_expertise') && !!host.get('description')
    case 'your-venue':
      return (
        !!host.getIn(['availabilities', 'frequency']) &&
        experience &&
        !!experience.get('experience_type') &&
        !!experience.getIn(['description', 'event_description'])
      )
    case 'your-photos':
      return (
        experience &&
        !!experience.getIn(['place', 'place_type']) &&
        !!experience.getIn(['description', 'neighbourhood'])
      )
    case 'our-policy-and-terms-and-conditions':
      return userFiles.size >= 5
    case 'congratulations':
      return metadata && (metadata.get('status') === 'to review' || metadata.get('status') === 're-submitted')
    default:
      return false
  }
}

export function getRedirectStep(pathname, data, userFiles, fromLastStep = false) {
  const metadata = data.get('metadata')
  if (metadata.get('status') && metadata.get('schema_version') === `${HOST_APPLICATION_SCHEMA_VERSION}`) {
    // application needs changes, go to Sample Experience section
    if (metadata.get('status').toLowerCase() === HOST_APPLICATION_STATUSES.REJECTED) {
      return '/host-application/your-motivations'
    }
    // to review, re-submitted or approved, go to last page
    if (
      ![HOST_APPLICATION_STATUSES.DRAFT, HOST_APPLICATION_STATUSES.UNSUPPORTED_AREA].includes(
        metadata.get('status').toLowerCase(),
      )
    ) {
      return STEPS[STEPS.length - 1]
    }
  }

  let lastValidStep
  const currentIndex = STEPS.indexOf(pathname)
  const stepsToCheck = fromLastStep ? STEPS : STEPS.slice(0, currentIndex + 1)

  for (const step of stepsToCheck) {
    if (!isStepValid(step, data, userFiles)) break
    lastValidStep = step
  }

  return lastValidStep
}
